<template>
   <div class="fusion-time fusion-grid-page  ">
      <NotFound v-if="!fusiongridLandingData" />
      <div v-if="fusiongridLandingData" class="content">
         <div class="main-content-block pl-3">
            <h1 class="mb-1">{{ fusiongridLandingData.overview.header }}</h1>
            <p class="lead">
               {{ descriptionJoiner(fusiongridLandingData.overview.shortDescription) }}
            </p>
            <div
               class="marked-header"
               v-html="markedRender(fusiongridLandingData.overview.longDescription)"
            />
         </div>

         <!-- What can you do with FusionExport?  -->
         <div class="row mb-6 what_can_do">
            <div class="col-12">
               <Intersected>
                  <WhatCan :config="fusiongridLandingData.whatCanFE.data" />
               </Intersected>
            </div>
         </div>
         <!-- What can you do with FusionExport?  -->
         <div class="main-content-block pt-3 pt-lg-3">
            <h2 class="text-center mb-3">{{ fusiongridLandingData.useCase.header }}</h2>
            <div class="card-deck card-deck-special">
               <div
                  v-for="(item, index) in fusiongridLandingData.useCase.cards"
                  :key="index"
                  class="card"
               >
                  <div class="card-content">
                     <div class="card-header pb-0">
                        <div class="card-heading-wrapper d-flex align-items-center">
                           <h3 class="card-title mb-0" v-text="item.header" />
                           <i :class="['icon', item.className]" />
                        </div>
                        <hr />
                     </div>
                     <div class="card-body special-crd">
                        <p>{{ item.description }}</p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="main-content-block pt-6 pb-6">
            <h2 class="text-center mb-3">{{ fusiongridLandingData.features.header }}</h2>
            <div class="card-deck card-deck-special">
               <div
                  v-for="(item, index) in fusiongridLandingData.features.cards"
                  :key="index"
                  class="card"
               >
                  <div class="card-content">
                     <div class="card-header pb-0 mb-2 text-center">
                        <img
                           style="cursor:pointer;"
                           class="img-fluid feature-images"
                           :src="item.src"
                           :alt="item.name"
                           @click="(isModalVisible = true), (iframesrc = item.src)"
                        />
                     </div>
                     <div class="card-body pt-0">
                        <p class="card-title mb-1">{{ item.name }}</p>
                        <p class="card-description">{{ item.description }}</p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <!-- demo card -->
         <div id="dashboard" class="main-content-block demo_cards" style="position:relative;">
            <h2 class="text-center">{{ fusiongridLandingData.demoheading.header }}</h2>
            <p class="text-center">{{ fusiongridLandingData.demoheading.longDescription }}</p>
            <div class="demo-card-box row mb-3">
               <div
                  v-for="(demoCard, idx) in fusiongridLandingData.overview.headerData.body"
                  :key="demoCard.id"
                  class="col-xl-3 col-lg-6 col-sm-6 mb-2"
               >
                  <div :class="demoCardClassMap[idx]" class="card demo-card">
                     <div class="demo-card-cover"></div>
                     <div class="card-body demo-card-body body-carding">
                        <div class="card-title demo-card-title d-flex">
                           <span class="text-white"> {{ demoCard.header }} </span>
                           <i :class="demoCard.icon" />
                        </div>
                        <p class="card-text demo-card-text text-white">
                           {{ demoCard.description }}
                        </p>
                     </div>
                     <div class="card-footer pt-0">
                        <a
                           :href="`//www.fusioncharts.com${demoCard.ctas[0].link}`"
                           class="btn btn-outline-light"
                           target="_self"
                        >
                           {{ demoCard.ctas[0].header }}
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <!-- demo card -->
         <b-modal v-model="isModalVisible" class="modal-consulting" centered hide-footer>
            <!--<iframe
               height="400"
               style="width: 100%;"
               scrolling="no"
               title="Real-time data update - UpdateRow"
               :src="`https://codepen.io/fusioncharts/embed/${iframesrc}?default-tab=html%2Cresult`"
               frameborder="no"
               loading="lazy"
               allowtransparency="true"
               allowfullscreen="true"
            >
               See the Pen
               <a :href="`https://codepen.io/fusioncharts/pen/${iframesrc}`">
                  Real-time data update - UpdateRow</a
               >
               by FusionCharts (<a href="https://codepen.io/fusioncharts">@fusioncharts</a>) on
               <a href="https://codepen.io">CodePen</a>.
            </iframe>
            <iframe width="500px" style="border:none;" height="500px" :src="iframesrc" />-->
            <img loading="lazy" width="100%" style="border:none;" :src="iframesrc" />
         </b-modal>
         <div class="main-content-block pt-6">
            <h2 class="text-center mb-3">{{ fusiongridLandingData.compatibility.header }}</h2>
            <p class="text-center">
               {{ descriptionJoiner(fusiongridLandingData.compatibility.shortDescription) }}
            </p>
            <div
               class="marked-header"
               v-html="markedRender(fusiongridLandingData.compatibility.longDescription)"
            />
         </div>
         <div class="main-content-block pt-9 text-center cta-container">
            <div
               v-for="(item, index) in fusiongridLandingData.compatibility.ctas"
               :key="index"
               :class="['cta-container-aligned']"
            >
               <button v-if="index === 2" :class="['btn btn-primary-grad']">
                  {{ item.header }}
               </button>
               <a
                  v-else
                  :href="item.link"
                  :class="[getClass(item.header)]"
                  @click.prevent="$router.push(item.link).catch(() => {})"
               >
                  {{ item.header }}
               </a>
            </div>
         </div>

         <!--License Information -->
         <div class="form-wrapper">
            <div class="">
               <div class="pb-4">
                  <div class="row">
                     <div class="col-12">
                        <div class="card card-bordered shadow-sm card-special">
                           <div class="card-body p-3">
                              <h5 class="mb-2">
                                 <strong> {{ fusiongridLandingData.license.header }}</strong>
                              </h5>
                              <div class="card-license-description">
                                 <div
                                    v-html="
                                       markedRender(fusiongridLandingData.license.longDescription)
                                    "
                                 />
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <!--License Information -->
         <!--Trial Information -->
         <div class="form-wrapper">
            <div class="">
               <div class="pb-2">
                  <div class="row">
                     <div class="col-12">
                        <div class="card card-bordered shadow-sm card-special">
                           <div class="card-body p-3">
                              <h5 class="mb-2">
                                 <strong> {{ fusiongridLandingData.trial.header }}</strong>
                              </h5>
                              <div class="card-license-description">
                                 <div
                                    v-html="
                                       markedRender(fusiongridLandingData.trial.longDescription)
                                    "
                                 />
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <!--Trial Information -->

         <!--GetStarted-->
         <div class="get-started">
            <h2 class="get-started__heading text-center">
               {{ fusiongridLandingData.getStarted.header }}
            </h2>
            <div class="get-started__ctas">
               <a
                  v-if="
                     fusiongridLandingData.getStarted &&
                        fusiongridLandingData.getStarted.ctas[0] &&
                        fusiongridLandingData.getStarted.ctas[0].link
                  "
                  target="_top"
                  :href="fusiongridLandingData.getStarted.ctas[0].link"
                  class="btn btn-primary-grad get-started__ctas-btn"
                  >{{ fusiongridLandingData.getStarted.ctas[0].header }}</a
               >
               <a
                  v-if="
                     fusiongridLandingData.getStarted &&
                        fusiongridLandingData.getStarted.ctas[1] &&
                        fusiongridLandingData.getStarted.ctas[1].link
                  "
                  target="_top"
                  :href="fusiongridLandingData.getStarted.ctas[1].link"
                  class="btn btn-outline-primary get-started__ctas-btn"
                  >{{ fusiongridLandingData.getStarted.ctas[1].header }}</a
               >
               <button
                  v-if="
                     fusiongridLandingData.getStarted &&
                        fusiongridLandingData.getStarted.ctas[2] &&
                        fusiongridLandingData.getStarted.ctas[2].link
                  "
                  class="btn btn-outline-primary get-started__ctas-btn"
                  @click="modalShowContactSales = !modalShowContactSales"
               >
                  {{ fusiongridLandingData.getStarted.ctas[2].header }}
               </button>
            </div>
         </div>
         <!--Contact Sales Modal Component-->
         <b-modal v-model="modalShowContactSales" centered hide-footer>
            <ContactSales />
         </b-modal>
         <!--GetStarted-->
      </div>
   </div>
</template>

<script>
import { mapState } from 'vuex';
import metaGenerator from '../../util/meta.js';
import ContactSales from '../../components/elforms/Sales';
import Intersected from '../../components/core/Intersected';
import WhatCan from '../../components/fusionexport/WhatCan.vue';
// import ChartView from '../../components/playground/ChartView.vue';
// import baseDropDown from '../../components/core/BaseDropdown';

export default {
   name: 'FusionGridx',
   components: {
      ContactSales,
      Intersected,
      WhatCan,
      // ChartView,
      // baseDropDown,
   },

   data() {
      return {
         selectedChartType: { code: {}, preview: null, header: null },
         selectedTab: null,
         selectedIndex: 0,
         ...(process.browser && { mixpanelanyProductPageTracker: this.$tracker.anyProductPage }),
         breakpoints: {
            small: 992,
         },
         tabSwiperOptions: {
            slidesPerView: 'auto',
            slidesPerGroup: 5,
            spaceBetween: 0,
            freeMode: true,
            navigation: {
               nextEl: '.swiper-button-next',
               prevEl: '.swiper-button-prev',
            },
         },
         isModalVisible: false,
         modalShowContactSales: false,
         iframesrc: false,
         isClient: false,
         demoCardClassMap: [
            'demo-card__ocean',
            'demo-card__purple',
            'demo-card__orange',
            'demo-card__blue',
         ],
      };
   },
   computed: {
      ...mapState(['fusiongridLandingData']),
   },
   watch: {
      selectedTab(val) {
         for (let i = 0, ii = this.chartTypes.length; i < ii; i++) {
            if (this.chartTypes[i].header === val) {
               if (i !== this.selectedIndex) {
                  this.selectedIndex = i;
               }
               break;
            }
         }
      },
      selectedIndex(val) {
         this.selectedTab = this.chartTypes[val].header;
         this.selectedChartType = this.chartTypes[val];
      },
   },

   asyncData({ store }) {
      return Promise.all([store.dispatch('OVERVIEW_FUSION_GRID_PAGE_DATA_FETCH')]);
   },

   mounted() {
      if (this.$route.hash) {
         this.scrollToSection('dashboard');
      }
      this.isClient = true;
      document.querySelector('#openSalesForm_lic').addEventListener('click', this.openContact);
      document.querySelector('#openSalesForm_trial').addEventListener('click', this.openContact);
      // eslint-disable-next-line
      //this.selectedChartType = this.chartTypes[0];
      // this.mixpanelanyProductPageTracker.visited();
      this.$store.commit('SET_SIDEBAR_FLAG', {
         data: true,
      });
      this.mixpanelanyProductPageTracker.visited();
   },

   methods: {
      checkMobileView() {
         const val = this.$mq;
         if (val === 'sm' || val === 'xs' || val === 'md') {
            return true;
         }
         return false;
      },
      goTo(url) {
         this.$router.push(url).catch(err => {});
      },
      openContact() {
         this.modalShowContactSales = true;
      },
      scrollToSection(id) {
         let value = document.getElementById(id).offsetTop;
         // console.log(value);
         if (this.checkMobileView()) {
            value = 7500;
            // console.log("testing mobile ");
         } else {
            value -= 100;
         }
         // console.log(`asdasd${value}`);
         fusionDesign.scroll.to(value, 'easeInOutExpo');
         /* const currentPos = document.documentElement.scrollTop;
         const elem = document.getElementById(id);
         const bodyRect = document.body.getBoundingClientRect();
         const elemRect = elem.getBoundingClientRect();
         const goingTo = elemRect.top - bodyRect.top;

         const travelTime =
            Math.abs(currentPos - goingTo) > 1200
               ? 1000
               : (Math.abs(currentPos - goingTo) * 1000) / 1200;

         fusionDesign.scroll.to(goingTo - 100, Math.round(travelTime), 'easeInOutExpo');
         return true; */
      },
   },

   metaInfo() {
      return metaGenerator(this.fusiongridLandingData);
   },
};
</script>

<style lang="scss" scoped>
.content {
   padding: 30px 0;

   @media (min-width: 576px) {
      padding: 30px;
   }

   @media (min-width: 800px) {
      padding: 50px 30px 30px 30px;
   }

   @media (min-width: 992px) {
      padding: 50px 51px 50px 51px;
   }

   @media (min-width: 1200px) {
      padding: 50px 51px 50px 51px;
   }
}
.get-started {
   padding: 80px 38px 0 38px;
   margin-bottom: 75px;
}
.get-started__ctas {
   flex-direction: row;
   justify-content: center;
   display: flex;
   align-items: center;
   margin-top: 36px;
   @media (max-width: 800px) {
      display: grid;
   }
}
.get-started__ctas-btn {
   margin-bottom: 25px;
   width: 166px;
   padding: 13px 24px;
   line-height: 16px;
}
.get-started__ctas-btn {
   width: auto;
   margin-right: 18px;
}
</style>

<style lang="scss">
.fusion-time {
   overflow: hidden;
   background-color: #f9f9fb;
   width: 100%;
   padding: 0;

   .base-drop-down {
      width: 100%;
      margin-bottom: 20px;
   }

   .card-deck-special {
      .card {
         background: none;
         border-radius: 0;
         margin: 0;
         padding: 10px 15px 20px;

         flex: 0 0 auto;
         min-width: 100%;
         max-width: 100%;

         @media (min-width: 567px) {
            flex: 0 0 auto;
            min-width: 50%;
            max-width: 50%;
         }

         @media (min-width: 1200px) {
            flex: 0 0 auto;
            min-width: 33.33%;
            max-width: 33.33%;
         }
         // @media (min-width: 1440px) {
         //    flex: 0 0 auto;
         //    min-width: 25%;
         //    max-width: 25%;
         // }

         .card-text {
            color: #686980;
            font-size: 16px;
            letter-spacing: 0.23px;
            line-height: 24px;
         }

         p.card-text {
            color: #212344;
            font-weight: 600;
         }

         .card-title {
            font-size: 16px;
            letter-spacing: 0.23px;
            line-height: 20px;
            color: #212344;
         }

         .card-content {
            height: 100%;
            background: #fff;
            border-radius: 5px;
            box-shadow: 0 6px 14px 0 rgba(33, 35, 68, 0.05) !important;
         }

         a.card-content {
            transition: all 0.2s ease;
            text-decoration: none;
            &:hover {
               transform: translateY(-4px);
               transition: all 0.2s ease;
            }
         }

         .feature-images {
            max-height: 240px;
         }
      }
   }

   .tab-header {
      display: flex;
      align-items: center;
      span,
      .swiper-slide {
         color: #73748c;
         font-size: 12px;
         font-weight: 600;
         letter-spacing: 0.15px;
         line-height: 15px;
      }

      .swiper-container {
         margin: 0 0;
      }

      .swiper-slide {
         text-align: center;
         min-width: 130px;
      }
      @media (min-width: 1200px) {
         .swiper-slide {
            min-width: 156px;
         }
      }
      // .slider-box {
      //    max-width: auto !important;
      //    width: 100%;
      //    display: inline-block;
      // }
      span {
         display: inline-block;
      }

      .quick-demo {
         width: 100px;
      }
   }

   .chart-type-swiper-wrapper {
      //max-width: 53vw;
      max-width: 82vw;
   }

   .marked-header {
      p {
         margin-bottom: 1.6rem !important;
      }

      table {
         background-color: #ffffff;
         margin: 0 auto;
         border: 1px solid #eeeef2;
         width: 100%;
         max-width: 600px;
         th,
         td {
            padding: 11px 25px;
            border-bottom: 1px solid #eeeef2;
            border-right: 1px solid #eeeef2;
            img {
               padding-right: 10px;
            }
         }

         tr:first-child {
            border-left: 1px solid #eeeef2;
         }

         th {
            color: #212344;
            font-size: 14px;
            font-weight: 600;
            line-height: 22px;
         }
      }
   }

   .cta-container {
      &-aligned {
         display: inline-block;
         margin-bottom: 10px !important;
      }

      &-aligned:first-child {
         margin-right: 10px !important;
      }

      .btn-tertiary {
         font-size: 16px;
         text-decoration: underline;
      }
   }

   .card {
      .card-title {
         font-size: 16px;
         font-weight: 600;
         line-height: 24px;
      }
      .card-header {
         .icon {
            width: 78px;
            height: 59px;
            background-position-x: 0px;
         }
      }
      .card-description {
         color: #686980;
         letter-spacing: 0.23px;
         line-height: 24px;
      }
   }
   .cta-container-aligned {
      .btn {
         min-width: 200px;
      }
   }

   .chart-type-swiper-wrapper {
      //max-width: 53vw;
      max-width: 82vw;
   }

   .chart-type-swiper-header {
      flex: 0 0 auto;
      margin-right: 10px;
      text-transform: uppercase;
      font-size: 12px;
      font-weight: 600;
      color: #73748c;
   }

   .chart-type-swiper-wrapper {
      flex: 1 1 auto;
      overflow: hidden;
      // max-width: 50vw;
      @media (min-width: 992px) {
         // max-width: 50vw;
         max-width: 57vw;
      }
      @media (min-width: 1150px) {
         max-width: 64vw;
      }
      @media (min-width: 1400px) {
         //max-width: 56.5vw;
         max-width: 69vw;
      }
      @media (min-width: 1700px) {
         max-width: 71.8vw;
      }

      .swiper-button-next {
         top: 42px;
      }
   }
}

.slider-box {
   border-radius: 6px;
   overflow: hidden;
   position: relative;

   .swiper-wrapper {
      padding-bottom: 5px;
      .tab-item {
         cursor: pointer;
         width: auto !important;
         padding: 8px 12px;
         color: #73748c;
         margin-right: 10px;
         background-color: #ffffff;
         overflow: hidden;
         box-shadow: 0 2px 4px 0 rgba(62, 57, 107, 0.13);
         border-radius: 4px;

         span {
            margin-left: 5px;
            letter-spacing: 0.4px;
            line-height: 19px;
            font-size: 15px;
         }
         &:hover {
            color: #6957da;
         }
         &.active {
            span {
               color: #ffffff;
            }
            background-color: #6957da;
         }
      }
   }
}

.swiper-button-next,
.swiper-button-prev {
   height: 25px;
   width: 25px;
   background: #fff;
   border-radius: 50%;
   box-shadow: 0 2px 4px 0 rgba(104, 105, 128, 0.22);
   top: 68%;
}

.swiper-button-prev {
   left: 0;
}
.swiper-button-next {
   right: 0;
}
.fusion-grid-page .ft-atomicity,
.fusion-grid-page .icon.ft-browsers,
.fusion-grid-page .icon.ft-charttypes,
.fusion-grid-page .icon.ft-customize,
.fusion-grid-page .icon.ft-datapoints,
.fusion-grid-page .icon.ft-multivariate,
.fusion-grid-page .icon.icon-fcexp-9 {
   background-image: url(/public/images/fc-grid-icons.svg);
   background-size: 117%;
}

.fusion-grid-page .ft-atomicity {
   background-position: 0px -28px;
}
.fusion-grid-page .icon.ft-browsers {
   background-position: 0 -110px;
}
.fusion-grid-page .icon.ft-charttypes {
   background-position: 0 -193px;
}
.fusion-grid-page .icon.ft-customize {
   background-position: 0px -277px;
}
.fusion-grid-page .icon.ft-datapoints {
   background-position: 0 -363px;
}
.fusion-grid-page .icon.ft-multivariate {
   background-position: 0 -452px;
}
.fusion-grid-page .icon.icon-fcexp-9 {
   background-position: 0 -539px;
}
.fusion-grid-page-features .card-deck-special .card .feature-images {
   min-height: 122px !important;
   max-height: 122px;
}

// .swiper-wrapper {
//    max-width: 1000px;
//    width: auto;
//    margin: 0;
// }
@media (min-width: 576px) {
   .modal-md.modal-dialog {
      max-width: 80%;
   }
}
</style>

<style lang="scss" scoped>
@import '../../util';

.demo-card__blue,
.demo-card__purple,
.demo-card__orange,
.demo-card__ocean {
   .demo-card-cover {
      background-repeat: no-repeat;
      background-position: bottom;
   }
   .demo-card-body {
      padding-right: 4px !important;
      padding-left: 1.4rem !important;
   }
}

.demo-card__ocean {
   background: linear-gradient(134.27deg, #5a7dc7 0%, #4fe8d4 100%);

   .demo-card-cover {
      background-image: url('/public/images/blue_wave.svg');
   }
}

.demo-card__blue {
   background: linear-gradient(134.34deg, #9ea7fc 0%, #65b6f7 100%);

   .demo-card-cover {
      background-image: url('/public/images/purple-wave.svg');
   }
}

.demo-card__purple {
   background: linear-gradient(134.72deg, #7466db 0%, #d0a9e2 100%);

   .demo-card-cover {
      background-image: url('/public/images/purple_wave.svg');
   }
}

.demo-card__orange {
   background: linear-gradient(315deg, #fce38a 0%, #f38181 100%);

   .demo-card-cover {
      background-image: url('/public/images/orange_wave.svg');
   }
}
.demo-card-box .fc_fusioncharts {
   background: none;
   background-image: url(/public/images/Portfolio_Dashboard.png);
   width: 100px;
   height: 44px;
   background-repeat: no-repeat;
}
.demo-card-box .fc_fusioncharts:before {
   //content: "\E992";
   content: none;
}

.demo-card-box .fc_reports {
   background: none;
   background-image: url(/public/images/saas_dashboard.png);
   width: 60px;
   height: 44px;
   background-repeat: no-repeat;
}
.demo-card-box .fc_reports:before {
   //content: "\E992";
   content: none;
}
.demo-card-box .fc_flask {
   background: none;
   background-image: url(/public/images/Web_series_Dashboard.png);
   width: 81px;
   height: 44px;
   background-repeat: no-repeat;
}
.demo-card-box .fc_flask:before {
   //content: "\E992";
   content: none;
}
.demo-card-box .fc_React {
   background: none;
   background-image: url(/public/images/google_analytics_dashboard.png);
   width: 100px;
   height: 44px;
   background-repeat: no-repeat;
}
.demo-card-box .fc_React:before {
   //content: "\E992";
   content: none;
}
.demo-card {
   height: 100%;
   box-shadow: 0 2px 4px 0 rgba(104, 105, 128, 0.3);
   border-radius: 4px;
   position: relative;

   &-cover {
      position: absolute;
      height: 100%;
      width: 100%;
      z-index: 0;
   }

   .card-footer {
      z-index: 1;
   }

   &-title {
      // margin: -24px -24px 24px -24px;
      margin-bottom: 1.3rem;
      min-height: 85px;
      font-size: 19px;
      border-bottom: 1px solid rgba(#ffffff, 0.1);
      line-height: 1.3 !important;

      @media (max-width: 1024px) {
         min-height: 65px;
      }

      i {
         font-size: 35px;
         color: rgba(#ffffff, 0.6);
         margin-left: auto;

         &.fc_fusioncharts,
         &.fc_apex {
            font-size: 44px;
         }

         &.fc_highcharts {
            margin-top: 7px;
         }
         &.fc_d3 {
            margin-top: 3px;
         }
      }

      span {
         display: block;
         margin-right: 8px;
      }
   }

   &-body {
      padding-top: 13px;
      .btn {
         margin-top: auto;
         align-self: start;
      }
   }

   &-text {
      font-size: 16px;
      opacity: 0.8;
   }

   .btn-outline-light {
      padding: 0.7rem 1.55rem;
   }
}

// .card-special {
//    @include media-breakpoint-up(md) {
//       margin-right: 1.8%;
//    }
// }
.fusionexport-landing {
   width: 100%;
}

// .intro-content ::v-deep {
//    p:last-child {
//       margin-bottom: 0 !important;
//    }
// }

.badge {
   margin-top: -2rem;
   font-size: 12px;
   letter-spacing: 0.9px;
   line-height: 15px;
   color: #212344;
   border: 1px solid rgba(62, 57, 107, 0.13);
   border-radius: 2px;
   background-color: rgba(62, 57, 107, 0.04);
}
.card-transparent {
   background-color: transparent;
}

// .top-from-wrapper {
//    background: linear-gradient(180deg, #ffffff 0%, #fdfdfe 86.75%, #f9f9fb 100%);
// }
.bg-light-purple {
   background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 10%,
      rgba(248, 249, 253, 1) 16%,
      rgba(248, 249, 253, 1) 49%,
      rgba(248, 249, 253, 1) 87%,
      rgba(255, 255, 255, 1) 100%
   );
}

.btn-holder {
   .btn {
      margin-right: 8px !important;
   }

   @media (max-width: 567px) {
      flex-direction: column;

      a {
         margin-bottom: 10px;
      }
   }
}

.content {
   overflow: hidden;
   padding: 30px 10px;

   @include media-breakpoint-up(sm) {
      padding: 30px;
   }

   @include media-breakpoint-up(md) {
      padding: 50px 30px 40px 30px;
   }

   @include media-breakpoint-up(lg) {
      padding: 50px 25px 50px 25px;
   }
   @include media-breakpoint-up(xl) {
      padding: 50px 30px 50px 30px;
   }
}

.card-heading-wrapper {
   min-height: 80px;
}

.card-deck-special {
   margin-left: -15px;
   margin-right: -15px;
   .card {
      border-radius: 0;
      margin: 0;
      padding: 10px 15px 20px;
      flex: 0 0 auto;
      min-width: 100%;
      max-width: 100%;

      @media (min-width: 567px) {
         flex: 0 0 auto;
         min-width: 50%;
         max-width: 50%;
      }

      @media (min-width: 1200px) {
         flex: 0 0 auto;
         min-width: 33.33%;
         max-width: 33.33%;
      }
      // @media (min-width: 1440px) {
      //    flex: 0 0 auto;
      //    min-width: 25%;
      //    max-width: 25%;
      // }

      .card-title,
      .card-text {
         font-size: 16px;
         line-height: 29px;
      }

      .card-content {
         height: 100%;
         background: #fff;
         border-radius: 5px;
         border: 1px solid rgba(105, 87, 218, 0.06);
      }
   }
}

.card {
   .card-header {
      .icon {
         display: block;
         width: 83px;
         height: 60px;
         margin: 0 auto;
         background-position-x: 5px;
      }
   }
   .card-body {
      p {
         &:last-child {
            margin-bottom: 0;
         }
      }
   }
}

.power {
   .card {
      .card-header {
         .icon {
            background-position-x: -11px;
         }
      }
   }
}

.whatcan .card {
   .card-header {
      .icon {
         width: 140px;
      }
   }
}

.icon-fcexp-1 {
   background-position: 0 -26px;
}

.icon-fcexp-5 {
   background-position: 0 -442px;
}

.icon-fcexp-9 {
   background-position: 0 -861px;
}

.icon-fcexp-6 {
   background-position: 0 -554px;
}

.icon-fcexp-8 {
   background-position: 0 -763px;
}

.icon-fcexp-2 {
   background-position: 0 -129px;
}

.icon-fcexp-3 {
   background-position: 0 -230px;
}
.icon-fcexp-4 {
   background-position: 0 -334px;
}
.icon-fcexp-7 {
   background-position: 0 -650px;
}

.selected .tab-heading {
   float: right;
   width: 26%;
   margin: 0 0 0 auto;
}

.top-from-wrapper {
   &.sticky {
      background: #fff;
      box-shadow: 0 2px 4px 0 rgba(62, 57, 107, 0.04);
      z-index: 100;
   }
}

.section {
   margin-left: 2px;
}

.lang-icon-list {
   margin-right: -2px;
   margin-left: -2px;
   li {
      padding: 2px;
      i {
         display: block;
         padding: 5px;
         border-radius: 50%;
         background-color: #ececec;
         border: 1px solid #f1f1f1;
         opacity: 0.9;
      }
   }
}

#v-pills-tab ::v-deep {
   a {
      width: 100%;
      background-color: transparent;
      box-shadow: none;
      padding: 1.4rem 2.2rem;
      .icon {
         padding: 7px 12px;
         display: block;
         background: #fff !important;
         color: #73748c;
         width: 30px;
         height: 30px;
         border-radius: 50%;
         box-shadow: 0 2px 4px 0 rgba(62, 57, 107, 0.13);
         margin-right: 1.5rem;
         font-size: 14px;
      }
      span {
         color: #686980;
      }

      &.active {
         background-color: #6957da;
         box-shadow: 0 4px 9px 0 rgba(23, 28, 33, 0.06);
         span {
            color: #fff;
         }
      }
   }
}

/*Should be remove if tab layout is implemented*/
// .tab-content {
//    max-width: 1000px;
//    margin: 0 auto;
// }

.card-license-description ::v-deep {
   p {
      margin-bottom: 0 !important;
   }
}

i.small {
   display: inline-block;
   font-size: 110%;
   vertical-align: middle;
   margin-right: 10px;
}

i.fc_highcharts {
   font-size: 28px !important;
}
.card-header.pb-0.mb-2.text-center {
   min-height: 133px;
}
</style>
<style>
.fc_inline_charts {
   background: none !important;
   background-image: url(/public/images/fc_use_grid_icon.svg) !important;
   width: 45px;
   height: 39px;
   background-repeat: no-repeat !important;
   background-position: center !important;
}
.fc_pagination {
   background: none !important;
   background-image: url(/public/images/fc_use_dashboard_icon.svg) !important;
   width: 45px;
   height: 39px;
   background-repeat: no-repeat !important;
   background-position: center !important;
}
.active i.fc_pagination {
   background-image: url(/public/images/fc_use_dashboard_icon_active.svg) !important;
   background-color: white !important;
}
.fc_inline_charts {
   background: none !important;
   background-image: url(/public/images/fc_line_chart.svg) !important;
   width: 45px;
   height: 39px;
   background-repeat: no-repeat !important;
   background-position: center !important;
}

.active i.fc_inline_charts {
   background-image: url(/public/images/fc_line_chart_active.svg) !important;
   background-color: white !important;
}
i.fc_line_chart:before,
.active i.fc_line_chart:before {
   background: none !important;
   content: none !important;
}
.fc_line_chart {
   background: none !important;
   background-image: url(/public/images/fc_use_grid_icon.svg) !important;
   width: 45px;
   height: 39px;
   background-repeat: no-repeat !important;
   background-position: center !important;
}

.active i.fc_line_chart {
   background-image: url(/public/images/fc_use_grid_icon_blue.svg) !important;
   background-color: white !important;
}
</style>
